import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icons } from "../assets/icons/Icons";

function BackHeader({ title, onClick }) {
    const navigate = useNavigate();
    return (
        <div className="d-flex justify-content-start pt-3 mx-2 pb-3">
            <Link
                onClick={() => {
                    if (onClick) {
                        return onClick();
                    }
                    navigate(-1);
                }}
            >
                <Icons.BackWithBG />
            </Link>
            <h2 className="font-33 font-700" style={{ marginLeft: "12px" }}>
                {title}
            </h2>
        </div>
    );
}

export default BackHeader;
